import { useState } from "react";
import { FaRedo } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {
  InstallationPickerRow,
  InstallationPickerSheet,
} from "./InstallationPickerSheet";

const InstallationImageReadingsResetSection = ({
  disabled,
  saving,
  onConfirm,
  adminOnly = false,
  divided = false,
}) => {
  const { t } = useTranslation();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleOpenConfirm = () => {
    if (!disabled && !saving) {
      setConfirmOpen(true);
    }
  };

  const handleDismiss = () => {
    if (!saving) {
      setConfirmOpen(false);
    }
  };

  const handleConfirm = async () => {
    const success = await onConfirm();
    if (success) {
      setConfirmOpen(false);
    }
  };

  return (
    <>
      <div className="installation-settings-reset-row">
        <InstallationPickerRow
          icon={FaRedo}
          iconVariant="reset"
          title={t("installation_image_readings_reset_title")}
          subtitle={t("installation_image_readings_reset_subtitle")}
          onClick={handleOpenConfirm}
          disabled={disabled || saving}
          adminOnly={adminOnly}
          divided={divided}
        />
      </div>

      <InstallationPickerSheet
        open={confirmOpen}
        title={t("installation_image_readings_reset_confirm_title")}
        onDismiss={handleDismiss}
        onSave={handleConfirm}
        saveLabel={t("installation_image_readings_reset_confirm_action")}
        dirty
        saving={saving}
      >
        <div className="installation-picker-confirm-content">
          <p className="installation-picker-confirm-body">
            {t("installation_image_readings_reset_confirm_body")}
          </p>
          <ul className="installation-picker-confirm-list">
            <li>{t("installation_image_readings_reset_confirm_schedule")}</li>
            <li>{t("installation_image_readings_reset_confirm_sides")}</li>
            <li>{t("installation_image_readings_reset_confirm_brightness")}</li>
          </ul>
        </div>
      </InstallationPickerSheet>
    </>
  );
};

export default InstallationImageReadingsResetSection;
